// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isDeliverabilityPostmasterLatestEventResult = objectOf({
  date: maybe(string, true),
});
